import { render, staticRenderFns } from "./MewSheet.vue?vue&type=template&id=124e841e"
var script = {}
import style0 from "./MewSheet.vue?vue&type=style&index=0&id=124e841e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports